import React from 'react';
import { SaveRegistrationContext } from '@/saveRegistration/SaveRegistrationContext.ts';

export const useSaveRegistration = () => {
  return React.useContext(SaveRegistrationContext);
};
